import { Input } from "@repo/skapa";
import { useDebouncedEffect } from "@repo/ui";
import { type ChangeEvent, useState } from "react";

interface DebouncedSearchFieldProps {
  value?: string;
  debounceTime?: number;
  label?: string;
  onChange: (term: string) => void;
}

export const DebouncedInputField = ({
  value,
  debounceTime = 500,
  label,
  onChange,
}: DebouncedSearchFieldProps) => {
  const [searchValue, setSearchValue] = useState<string | undefined>(value);
  useDebouncedEffect(
    () => {
      if (searchValue !== undefined && value !== searchValue) {
        onChange(searchValue);
      }
    },
    debounceTime,
    [searchValue]
  );
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const inputValue = event.currentTarget.value;
    setSearchValue(inputValue);
  };

  return (
    <Input
      id="debounced-input-field"
      label={label}
      onChange={(e) => {
        handleChange(e);
      }}
      value={searchValue ?? value ?? ""}
      type="text"
    />
  );
};
